import { createSlice, createAction, PayloadAction } from '@reduxjs/toolkit'
import { OnboardingChecklistTaskProps } from '../types'
import { ApiError, RequestStatus } from 'features/common'
import { Task } from 'features/onboarding-checklist/types'

export const name = 'onboardingChecklist'

export interface OnboardingChecklistState {
  completed: boolean
  tasks: OnboardingChecklistTaskProps[] | null
  open?: boolean
  showCompletionConfirmation?: boolean
  status?: RequestStatus
  error?: ApiError
  updateStatus?: RequestStatus
  updateError?: ApiError
  videos: Task[] | null
}

const initialState: OnboardingChecklistState = {
  completed: false,
  tasks: null,
  open: false,
  showCompletionConfirmation: false,
  status: RequestStatus.Idle,
  updateStatus: RequestStatus.Idle,
  videos: null
}

const asyncActions = {
  getOnboardingChecklistRequest: createAction(`${name}/get_onboarding_checklist`),
  completeOnboardingChecklistRequest: createAction<'SkipOnBoarding' | string[]>(`${name}/complete_onboarding_checklist`)
}

const reducers = {
  setOnboardingChecklist: (state: OnboardingChecklistState, action: PayloadAction<OnboardingChecklistState>) => {
    const { completed, tasks, videos } = action.payload
    state.completed = completed
    state.tasks = tasks
    state.videos = videos
  },
  setOnboardingChecklistOpen: (state: OnboardingChecklistState, action: PayloadAction<boolean>) => {
    state.open = action.payload
  },
  showOnboardingChecklistCompletionConfirmation: (state: OnboardingChecklistState, action: PayloadAction<boolean>) => {
    state.showCompletionConfirmation = action.payload
  },
  setOnboardingChecklistStatus: (state: OnboardingChecklistState, action: PayloadAction<RequestStatus>) => {
    state.status = action.payload
  },
  setOnboardingChecklistError: (state: OnboardingChecklistState, action: PayloadAction<ApiError>) => {
    state.error = action.payload
  },
  setOnboardingChecklistUpdateStatus: (state: OnboardingChecklistState, action: PayloadAction<RequestStatus>) => {
    state.updateStatus = action.payload
  },
  setOnboardingChecklistUpdateError: (state: OnboardingChecklistState, action: PayloadAction<ApiError>) => {
    state.updateError = action.payload
  }
}

export const onboardingChecklistSlice = createSlice({
  name,
  initialState,
  reducers
})

export const {
  setOnboardingChecklist,
  setOnboardingChecklistOpen,
  showOnboardingChecklistCompletionConfirmation,
  setOnboardingChecklistStatus,
  setOnboardingChecklistError,
  setOnboardingChecklistUpdateStatus,
  setOnboardingChecklistUpdateError
} = onboardingChecklistSlice.actions

export const { getOnboardingChecklistRequest, completeOnboardingChecklistRequest } = asyncActions

export default onboardingChecklistSlice.reducer
